import { alertUiAdminPages } from '@juvare/alert-ui/ui/features/classifiers-admin-pages';
import { getContactManagementAdminPages } from '@juvare/contact-management/ui/features/classifiers-admin-pages';
import { contactUsAdminPages } from '@juvare/contact-management/ui/features/contact-us/components/ContactUsAdminPages';
import { getCredentialingAdminPages } from '@juvare/credentialing/ui/features/classifiers-admin-pages';
import { missionAdminPages } from '@juvare/missions/ui/features/mission-admin-pages';
import { UserState } from '@juvare/platform-sdk-react/types';
import { ConfigurationPageDef } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { useDefaultClassifierAdminPages } from '@juvare/platform-sdk-react/ui/features/default-classifiers';
import { getUserState } from '@juvare/platform-sdk-react/ui/stores';
import { useSelector } from 'react-redux';

export function useConfigurationPages() {
    const userState = useSelector(getUserState);
    const defaultClassifierPages = useDefaultClassifierAdminPages();
    const configurationPagesUnsorted = (userState: UserState): ConfigurationPageDef[] => [
        ...defaultClassifierPages,
        ...getContactManagementAdminPages(userState),
        ...getCredentialingAdminPages(userState),
        ...missionAdminPages,
        ...contactUsAdminPages,
        ...alertUiAdminPages,
    ];

    const sortedConfigurationPages = [...configurationPagesUnsorted(userState)].sort((a, b) => a.label.localeCompare(b.label));
    return { sortedConfigurationPages };
}
